import styled from "styled-components";

export const ModalSeleccionBusquedaContainer = styled.div`
  padding: 12px 32px;
`;
export const ModalSeleccionBusquedaBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 0;
`;
export const ModalSeleccionBusquedaItem = styled.div`
  border: 1px solid var(--color-grey85);
  border-radius: 8px;
  height: 42px;
  width: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-latex10);
  user-select: none;
`;
export const ModalSeleccionBusquedaFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .ModalSeleccionBusqueda-btn {
    width: 132px;
    height: 38px;
    color: var(--color-white);
    background-color: var(--color-latex10);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
  }
`;
